import { Settings } from "lucide-react";
import CompanySetingsForm from "../components/forms/CompanySetingsForm";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../utils/components/ui/tabs";
import BranchList from "../components/BranchList";
import CounterList from "../components/CounterList";

function CompanySettings() {
  return (
    <div className="space-y-6 p-6">
      {/* Page header */}
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-[12px] bg-[#EEF3FF] flex items-center justify-center">
          <Settings className="w-5 h-5 text-[#1A5EF9]" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-[#1A2B4A]">Settings</h1>
          <p className="text-sm text-[#8A9BB5]">
            Manage your company profile, branches and counters
          </p>
        </div>
      </div>

      <Tabs defaultValue="profile">
        <TabsList className="h-11 bg-[#F0F4FF] rounded-[12px] p-1 gap-1 w-auto inline-flex">
          <TabsTrigger
            value="profile"
            className="h-9 px-5 rounded-[10px] text-sm font-medium text-[#52627C] data-[state=active]:bg-[#1A5EF9] data-[state=active]:text-white data-[state=active]:shadow-[0_2px_8px_rgba(26,94,249,0.25)] transition-all"
          >
            Company Profile
          </TabsTrigger>
          <TabsTrigger
            value="branch"
            className="h-9 px-5 rounded-[10px] text-sm font-medium text-[#52627C] data-[state=active]:bg-[#1A5EF9] data-[state=active]:text-white data-[state=active]:shadow-[0_2px_8px_rgba(26,94,249,0.25)] transition-all"
          >
            Branch Settings
          </TabsTrigger>
          <TabsTrigger
            value="counter"
            className="h-9 px-5 rounded-[10px] text-sm font-medium text-[#52627C] data-[state=active]:bg-[#1A5EF9] data-[state=active]:text-white data-[state=active]:shadow-[0_2px_8px_rgba(26,94,249,0.25)] transition-all"
          >
            Counter Settings
          </TabsTrigger>
        </TabsList>

        <TabsContent value="profile" className="mt-6">
          <CompanySetingsForm />
        </TabsContent>
        <TabsContent value="branch" className="mt-6">
          <BranchList />
        </TabsContent>
        <TabsContent value="counter" className="mt-6">
          <CounterList />
        </TabsContent>
      </Tabs>
    </div>
  );
}

export default CompanySettings;
